import { render, staticRenderFns } from "./ForgotPasswordBox.vue?vue&type=template&id=8f8e38c4&"
import script from "./ForgotPasswordBox.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports